
export default {
  data () {
    return {
      outerVisible: false
    }
  },
  methods: {
    closeClick () {
      this.outerVisible = false
    }
  }
}
